var map = {
	"./blog.yml": 110,
	"./cloud.yml": 111,
	"./color.yml": 112,
	"./country.yml": 113,
	"./dio.yml": 114,
	"./doc.yml": 115,
	"./emoji.yml": 116,
	"./git.yml": 117,
	"./icon.yml": 118,
	"./license.yml": 119,
	"./link.yml": 120,
	"./metrics.yml": 121,
	"./people.yml": 122,
	"./soft.yml": 123,
	"./src.yml": 124,
	"./status.yml": 125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;